export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * Convert a label to sentence case — only the first letter is capitalised, the rest lowercased
 */
export const toSentenceCase = (str: string) => {
  const trimmed = str.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};

export const replaceWhiteSpaces = (str: string, char = '_') => str.replace(/[\s]/g, () => `${char}`);

export const stringToFixedDigitFloat = (value: string, digit: number) => {
  const parsedNumber = Number.parseFloat(value);
  return Number(Number.isNaN(parsedNumber) ? 0 : parsedNumber.toFixed(digit));
};

export function nullToStringNull(value: null | string) {
  return value === null ? 'null' : value;
}

export function nullishStringToNull(value: string | null) {
  if (value === '' || value === 'null') {
    return null;
  }

  return value;
}

export const notNull = <TItem>(item: TItem): item is NonNullable<TItem> => item !== null;

export function getStringWidth(textContent: string, classList: Array<string>) {
  const fakeElement = document.createElement('div');
  Object.assign(fakeElement.style, {
    display: 'block',
    pointerEvents: 'none',
    position: 'absolute',
    visibility: 'hidden',
    zIndex: '-1',
  });
  fakeElement.textContent = textContent;
  fakeElement.classList.add(...classList);

  // Append the element to the body to calculate its width
  document.body.appendChild(fakeElement);

  const inputValueWidth = fakeElement.getBoundingClientRect().width;

  // Remove the element from the DOM after getting its width
  document.body.removeChild(fakeElement);

  return inputValueWidth;
}
